import React, { useEffect, useState } from "react";
import { Stack, LinearProgress, Button, Modal, Container  } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import HoaOnboardingDetailsModal from "./hoa-onboarding-details-modal";
import OnboardingState from "./hoa-onboarding-state";
import datastore from "../../store/hoa-datastore";

export default function HoaOnboardingForm({ onboardingDataState, previousOnboardingDataState, setOnboardingDataState, onboardingDocuments, setOnboardingDocuments }: any) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeState, setActiveState] = useState(5);

    useEffect(() => {
        calculateActiveState();
    }, []);

    const handleModalClose = (event?:any, reason?:any) => {
        if (reason && reason === "backdropClick") {
            return;
        }

        calculateActiveState();
        setIsModalOpen(false);
    }

    const onCompleteOnboardingClick = () => {
        calculateActiveState();
        setIsModalOpen(true);
    }

    const testOnClickState = (testState:any) => {
        setIsModalOpen(true);
        setActiveState(testState)
    }

const markAsCompletedBtnClicked = () => {
    const today = new Date();
    const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear()}`;
    const onboardingStates = ["clientDirectory", "portalSearch", "emailHoa", "callHoa"];
    const currentStateKey = onboardingStates[activeState - 1];

    const updatedState = {
        ...onboardingDataState[currentStateKey],
        isCompleted: true,
        completedBy: datastore.ownerInformation.name,
        completedAt: formattedDate,
        ...(currentStateKey === "clientDirectory" && { onboardingDate: formattedDate })
    };

    const tempState = {
        ...onboardingDataState,
        [currentStateKey]: updatedState
    };

    setOnboardingDataState(tempState);
    setActiveState(activeState + 1);
    handleModalClose();
};


    const cancelBtnClicked = () => {
        const onboardingStates = ["clientDirectory", "portalSearch", "emailHoa","callHoa"];
        const copyOfPreviousOnboadingState = JSON.parse(JSON.stringify(previousOnboardingDataState[onboardingStates[activeState - 1]]));

        const tempState = {
            ...onboardingDataState,
            [onboardingStates[activeState-1]]: copyOfPreviousOnboadingState
        }
        
        setOnboardingDataState(tempState);

        // handle onboardingDocuments
        if (activeState == 1) {
            setOnboardingDocuments({
                ...onboardingDocuments,
                "clientDirectory": copyOfPreviousOnboadingState["data"]["documents"] || []
            });
        }
        else if (activeState == 2) {
            setOnboardingDocuments({
                ...onboardingDocuments,
                "portalSearch": copyOfPreviousOnboadingState["data"]["documents"] || []
            });
        }
        else if (activeState == 3) {
            setOnboardingDocuments({
                ...onboardingDocuments,
                "emailHoa": copyOfPreviousOnboadingState["data"]["documents"] || [],
                "emailHoaScreenshot": copyOfPreviousOnboadingState["data"]["screenshot"] || []
            });
        }
        else if (activeState == 4) {
            setOnboardingDocuments({
                ...onboardingDocuments,
                "callHoa": copyOfPreviousOnboadingState["data"]["documents"] || [],
                "callHoaScreenshot": copyOfPreviousOnboadingState["data"]["screenshot"] || []
            });
        }
        
        handleModalClose();
    }

    const isMarkAsCompletedBtnEnabled = () => {
        if (activeState == 1) {
            const data = onboardingDataState["clientDirectory"]?.data;

            if (onboardingDocuments["clientDirectory"]?.length > 0 || (Array.isArray(data["documents"]) && data["documents"].length > 0) 
                || data["hyperLink"] || data["remarks"] || data["isDataUnavailable"]) {

                return true;
            }
        }
        else if (activeState == 2) {
            const data = onboardingDataState["portalSearch"]?.data;
            
            if (onboardingDocuments["portalSearch"]?.length > 0 || (Array.isArray(data["documents"]) && data["documents"].length > 0) 
                || data["portalLink"] || data["remarks"] || data["isDataUnavailable"]) {
                    
                return true;
            }
        }
        else if (activeState == 3) {
            const data = onboardingDataState["emailHoa"]?.data;

            if (onboardingDocuments["emailHoa"]?.length > 0 || onboardingDocuments["emailHoaScreenshot"]?.length > 0 || (Array.isArray(data["documents"]) &&  data["documents"].length > 0) || (Array.isArray(data["screenshot"]) &&  data["screenshot"].length > 0) 
                || data["emailSourceId"] || data["obtainedInformation"] || data["remarks"]) {
                    
                return true;
            } 
        }
        else if (activeState == 4) {
            const data = onboardingDataState["callHoa"]?.data;

            if (onboardingDocuments["callHoa"]?.length > 0 || onboardingDocuments["callHoaScreenshot"]?.length > 0 || (Array.isArray(data["documents"]) &&  data["documents"].length > 0) || (Array.isArray(data["screenshot"]) &&  data["screenshot"].length > 0) 
                || data["phone"] || data["email"] || data["obtainedInformation"] || data["remarks"]) {
                    
                return true;
            } 
        }

        return false;
    }

    const calculateActiveState = () => {
        let active = 5;

        let index = 1;

        for (const key of Object.keys(onboardingDataState)) {
            if (!onboardingDataState[key].isCompleted) {
                active = index;
                break;
            }
            index ++;
        }

        setActiveState(active);
    }

    const onClickStage = (state:number) => {
        setActiveState(state);
        setIsModalOpen(true);
    }

    const shouldUpdateAvailable = (state:number) => {
        const onboardingStates = ["clientDirectory", "portalSearch", "emailHoa","callHoa"];
        const previous = previousOnboardingDataState[onboardingStates[state-1]];
        const now = onboardingDataState[onboardingStates[state-1]];

        if (previous?.isCompleted && now?.isCompleted) {
            return true;
        }

        return false;
    }

    return (
        <div style={{ borderBottom: "1px solid #E8E8E8",}}>
            <HoaOnboardingDetailsModal 
                isModalOpen={isModalOpen} 
                handleModalClose={handleModalClose} 
                cancelBtnClicked={cancelBtnClicked}
                activeState={activeState} 
                isEditMode={true}
                onboardingDocuments={onboardingDocuments}
                setOnboardingDocuments={setOnboardingDocuments}
                onboardingDataState={onboardingDataState}
                setOnboardingDataState={setOnboardingDataState}
                markAsCompletedBtnClicked={markAsCompletedBtnClicked}
                isMarkAsCompletedBtnEnabled={isMarkAsCompletedBtnEnabled}
                shouldUpdateAvailable={shouldUpdateAvailable}
            />
            <div style={{ background: '#FAFAFA', padding: '16px', border: '1px solid #E8E8E8', borderRadius: '4px' }}>
                <div style={{ display: 'flex', }}>
                    <div style={{ width: '80%', display: 'flex' }}>
                            <OnboardingState onClickStage={onClickStage} shouldUpdateAvailable={shouldUpdateAvailable} isCompleted={onboardingDataState["clientDirectory"].isCompleted} isActive={activeState == 1} stateNumber={1} stateName={"Client's Directory"} componentWidth={"180px"}/>
                            <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: '35px' }}><hr style={{ color: '#C5C5C5', width: '25px' }}/></div>
                            
                            <OnboardingState onClickStage={onClickStage} shouldUpdateAvailable={shouldUpdateAvailable} isCompleted={onboardingDataState["portalSearch"].isCompleted} isActive={activeState == 2} stateNumber={2} stateName={"Portal Search"}/>
                            <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: '35px' }}><hr style={{ color: '#C5C5C5', width: '25px' }}/></div>

                            <OnboardingState onClickStage={onClickStage} shouldUpdateAvailable={shouldUpdateAvailable} isCompleted={onboardingDataState["emailHoa"].isCompleted} isActive={activeState == 3} stateNumber={3} stateName={"Email HOA"}/>
                            <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: '35px' }}><hr style={{ color: '#C5C5C5', width: '25px' }}/></div>

                            <OnboardingState onClickStage={onClickStage} shouldUpdateAvailable={shouldUpdateAvailable} isCompleted={onboardingDataState["callHoa"].isCompleted} isActive={activeState == 4} stateNumber={4} stateName={"Call HOA"}/>
                    </div>
                    <Button
                        style={{
                            width: '20%',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#3E3E3E",
                            background: "#FFFFFF",
                            borderRadius: "4px",
                            border: "1px solid #E8E8E8"
                        }}
                        disabled={activeState > 4}
                        onClick={onCompleteOnboardingClick}
                    >
                        Complete Onboarding
                    </Button>
                </div>
            </div>
        </div>
    )
}